import type { IArrowIcon } from './helpers';

export const ArrowIcon = ({ variant, ...rest }: IArrowIcon) => {
	if (variant === 'rightCaret') {
		return (
			<svg
				width='6'
				height='10'
				viewBox='0 0 6 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M3.78438 5.00048L0.484375 1.70048L1.42704 0.757812L5.66971 5.00048L1.42704 9.24315L0.484375 8.30048L3.78438 5.00048Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'leftCaret') {
		return (
			<svg
				width='6'
				height='10'
				viewBox='0 0 6 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M2.22127 5.00048L5.52127 8.30048L4.5786 9.24315L0.335938 5.00048L4.5786 0.757812L5.52127 1.70048L2.22127 5.00048Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'leftDoubleCaret') {
		return (
			<svg
				width='10'
				height='10'
				viewBox='0 0 10 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M4.5 5L7.5 8L6.557 8.943L2.614 5L6.557 1.057L7.5 2L4.5 5Z'
					fill='currentColor'
				/>
				<path
					d='M1.5 5L4.5 8L3.557 8.943L-0.386 5L3.557 1.057L4.5 2L1.5 5Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'rightDoubleCaret') {
		return (
			<svg
				width='10'
				height='10'
				viewBox='0 0 10 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M5.5 5L2.5 2L3.443 1.057L7.386 5L3.443 8.943L2.5 8L5.5 5Z'
					fill='currentColor'
				/>
				<path
					d='M8.5 5L5.5 2L6.443 1.057L10.386 5L6.443 8.943L5.5 8L8.5 5Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'arrowDown') {
		return (
			<svg
				width='10'
				height='6'
				viewBox='0 0 10 6'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M5.00048 3.78047L8.30048 0.480469L9.24315 1.42314L5.00048 5.6658L0.757812 1.42314L1.70048 0.480469L5.00048 3.78047Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'arrowLeft') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...rest}
			>
				<path d='M19 12H5M5 12L12 5M5 12L12 19' />
			</svg>
		);
	}
	if (variant === 'arrowRight') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...rest}
			>
				<path d='M5 12H19M19 12L12 5M19 12L12 19' />
			</svg>
		);
	}
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<g clipPath='url(#clip0_6952_45306)'>
				<path
					d='M13.4768 9.16591L9.00683 4.69591L10.1852 3.51758L16.6668 9.99924L10.1852 16.4809L9.00683 15.3026L13.4768 10.8326H3.3335V9.16591H13.4768Z'
					fill='#565F7D'
				/>
			</g>
			<defs>
				<clipPath id='clip0_6952_45306'>
					<rect
						width='20'
						height='20'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
